import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    "data-placeholder": "暂无歌词",
    class: _normalizeClass(["lyric-view", {empty: _ctx.lyricList.length < 1}]),
    ref: element => void (_ctx.elements[-1] = element),
    onPointerdown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["content-wrapper", {animation: _ctx.scrollable}]),
      style: _normalizeStyle({transform: `translateY(${_ctx.translatedY}px)`})
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lyricList, (line, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["lyric-item", {active: _ctx.selectedIndex === index}]),
          key: index,
          ref_for: true,
          ref: element => void (_ctx.elements[index] = element)
        }, _toDisplayString(line.content), 3))
      }), 128))
    ], 6)
  ], 34))
}